var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlockPost = function SvgBlockPost(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 16.25,
    "data-width-24": 19.5,
    viewBox: "2 2 19.5 19.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.848 2.187A9.75 9.75 0 0 1 21.5 11.75a9.76 9.76 0 0 1-9.75 9.75A9.75 9.75 0 0 1 9.848 2.187m8.189 4.23a2 2 0 0 1-.339.445L6.738 17.823c-.093.091-.195.17-.297.24a8.25 8.25 0 0 0 8.466 1.309A8.25 8.25 0 0 0 20 11.75a8.26 8.26 0 0 0-1.963-5.332M11.75 3.5a8.25 8.25 0 0 0-6.315 13.558q.104-.155.242-.295l10.96-10.961c.137-.137.29-.252.444-.34A8.26 8.26 0 0 0 11.75 3.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlockPost);
export default ForwardRef;